import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { useAuth } from "@/lib/auth";
import { TID } from "@/lib/testIds";
import { toast } from "sonner";

export default function Signup() {
  const { signup, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [role, setRole] = useState("client");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);

  if (user) {
    nav("/app");
    return null;
  }

  async function submit(e) {
    e.preventDefault();
    setErr(null); setBusy(true);
    try {
      await signup(email, password, role, displayName || null);
      toast.success("Account created. Please verify your email.");
      nav("/app");
    } catch (e) {
      setErr(e?.problem?.detail || e?.problem?.title || e.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <Layout>
      <div className="max-w-md mx-auto avcp-card p-8">
        <h1 className="text-3xl">Create an account</h1>
        <p className="mt-2 text-sm text-[var(--avcp-ink-soft)]">Choose your path — you can change later.</p>
        <form onSubmit={submit} data-testid={TID.signupForm} className="mt-6 grid gap-4">
          <div className="grid grid-cols-2 gap-2">
            <button
              type="button"
              data-testid={TID.signupRoleClient}
              className={`avcp-btn ${role === "client" ? "primary" : "ghost"}`}
              onClick={() => setRole("client")}
            >
              I&apos;m hiring contractors
            </button>
            <button
              type="button"
              data-testid={TID.signupRoleContractor}
              className={`avcp-btn ${role === "contractor" ? "primary" : "ghost"}`}
              onClick={() => setRole("contractor")}
            >
              I&apos;m a contractor
            </button>
          </div>
          <label className="grid gap-1.5">
            <span className="text-sm font-medium">Email</span>
            <input
              data-testid={TID.signupEmail}
              className="avcp-input" type="email" required
              value={email} onChange={(e) => setEmail(e.target.value)} />
          </label>
          <label className="grid gap-1.5">
            <span className="text-sm font-medium">Name (optional)</span>
            <input className="avcp-input" value={displayName} onChange={(e) => setDisplayName(e.target.value)} />
          </label>
          <label className="grid gap-1.5">
            <span className="text-sm font-medium">Password</span>
            <input
              data-testid={TID.signupPassword}
              className="avcp-input" type="password" required minLength={12}
              value={password} onChange={(e) => setPassword(e.target.value)} />
            <span className="text-xs text-[var(--avcp-ink-soft)]">At least 12 characters. Mix letters, numbers, symbols.</span>
          </label>
          {err && <div className="text-sm text-[var(--avcp-danger)]">{err}</div>}
          <button data-testid={TID.signupSubmit} className="avcp-btn primary" disabled={busy}>
            {busy ? "Creating…" : "Create account"}
          </button>
        </form>
        <p className="mt-6 text-sm text-[var(--avcp-ink-soft)]">
          Already have an account? <Link className="avcp-link" to="/signin">Sign in</Link>
        </p>
      </div>
    </Layout>
  );
}
